import SizePriceBrackets from './size-price-brackets';
export default SizePriceBrackets;
